import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { FaPlay } from "react-icons/fa";
import { ArrowRight, ChevronLeft, Handbag, Info, X } from "lucide-react";
// ? Non so se className="text-generic" dovrebbe essere qui
const GenericButton = React.forwardRef(({ variant, size, icon, groupColor = false, purchaseInfo, asChild, children, ...props }, forwardRef) => {
    const { t } = useTranslation();
    const sm = `text-xs ${icon ? "py-4 px-2" : "p-4 w-36"}`;
    const md = `text-sm ${icon ? "py-6 px-4" : "p-6 w-42"}`;
    const renderContent = () => {
        switch (variant) {
            case "play":
                return (_jsxs(_Fragment, { children: [_jsx(FaPlay, {}), !icon && t("watch-now")] }));
            case "info":
                return !icon ? (_jsxs(_Fragment, { children: [t("more-info"), " ", _jsx(ArrowRight, {})] })) : (_jsx(Info, {}));
            case "rent":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: !icon ? (_jsxs(_Fragment, { children: [t("rent"), " ", purchaseInfo?.rentInfo && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs("span", { className: "whitespace-nowrap", children: [purchaseInfo.rentInfo.value, " ", t("for"), " ", purchaseInfo.rentInfo.rentTime] })] }))] })) : (_jsx(Handbag, {})) }));
            case "subscribe":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: !icon ? (_jsxs(_Fragment, { children: [t("subscribe"), purchaseInfo?.subscriptionInfo && (_jsxs(_Fragment, { children: [",", " ", t("n-days-for-free", {
                                        days: purchaseInfo.subscriptionInfo.trialPerdioDays,
                                    })] }))] })) : (_jsx(Handbag, {})) }));
            case "buycoin":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: !icon ? (_jsxs(_Fragment, { children: [t("buy"), purchaseInfo?.buyInfo
                                ? ` ${purchaseInfo.buyInfo.coinPrice} ${t("coin")}`
                                : ""] })) : (_jsx(Handbag, {})) }));
            case "buycash":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: !icon ? (_jsxs(_Fragment, { children: [t("buy"), purchaseInfo?.buyInfo
                                ? ` ${purchaseInfo.buyInfo.cashPrice}`
                                : ""] })) : (_jsx(Handbag, {})) }));
            case "signin":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: t("sign-in") }));
            case "signup":
                return (_jsx("span", { className: size === "sm" ? "text-[12px]" : "", children: t("sign-up") }));
            case "close":
                return icon ? _jsx(X, {}) : null;
            case "back":
                return icon ? _jsx(ChevronLeft, {}) : null;
            case "home":
                return (_jsxs(_Fragment, { children: [_jsx(ChevronLeft, {}), !icon && "Home"] }));
            default:
                return null;
        }
    };
    const content = renderContent();
    return (_jsx(Button, { role: "button " + variant, title: variant, "aria-label": "aria " + variant, ref: forwardRef, asChild: asChild, ...props, className: `${props.className ? props.className : ""} ${groupColor
            ? "bg-group-custom! hover:bg-group-custom-hover! hover:ring-group-custom/30! hover:outline-group-custom! hover:ring-3! hover:outline-2!"
            : "bg-transparent hover:bg-[#32354A]/30 hover:backdrop-blur-[22px]" // Richiesto da CO [Bug 9178]
        } wrap-break-words text-generic flex cursor-pointer items-center justify-center rounded-xl text-center whitespace-normal transition-all duration-200 ${size == "sm" ? sm : md} `, children: asChild
            ? React.cloneElement(children, {}, content)
            : content }));
});
export default GenericButton;
